export const programs = [
  // Data Analyst Track
  {
    date: "19 Jan - 24 Jan",
    title: "Business & Analytical Thinking",
    module: "Analytical Mindset",
    track: "Data Analyst",
    prerequisite: "",
    material: "Memahami bisnis problem, merubah ke analytical question, menentukan KPI yang tepat, framework problem solving",
    instructor: "",
    outcome: "Framework dokumen analisis bisnis dan template KPI Dashboard (Excel)",
    deliverable: "Business Analysis Framework Document",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  {
    date: "26 Jan - 31 Jan",
    title: "Excel for Data Cleaning",
    module: "Excel Fundamentals",
    track: "Data Analyst",
    prerequisite: "",
    material: "Teknik data cleaning dengan Excel, handling missing values, data formatting, remove duplicates, text to columns, find & replace",
    instructor: "",
    outcome: "File Excel portfolio: Clean Dataset dari Raw Data (sebelum & sesudah)",
    deliverable: "Cleaned Sales Dataset (Excel)",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  {
    date: "02 Feb - 07 Feb",
    title: "Excel for Data Analysis",
    module: "Pivot & Insight",
    track: "Data Analyst",
    prerequisite: "",
    material: "Pivot table, aggregation",
    instructor: "",
    outcome: "Pivot Table & Aggregation Courses",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  {
    date: "9 Feb - 14 Feb",
    title: "SQL for Data Analyst",
    module: "SQL Fundamentals",
    track: "Data Analyst",
    prerequisite: "",
    material: "SELECT, WHERE, JOIN, GROUP BY",
    instructor: "",
    outcome: "Materi mengenai SELECT, WHERE, JOIN, GROUP BY beserta soal latihan & jawaban yang sesuai dengan kebutuhan industri.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  {
    date: "18 Feb - 21 Feb",
    title: "Python for Data Analysis",
    module: "Exploratory Data Analysis",
    track: "Data Analyst",
    prerequisite: "",
    material: "Pandas, NumPy, EDA workflow",
    instructor: "",
    outcome: "Materi mengenai librari Python seperti Pandas, NumPy, EDA Workflow",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  {
    date: "23 Feb - 28 Feb",
    title: "Data Visualization & Storytelling",
    module: "Visual Analytics",
    track: "Data Analyst",
    prerequisite: "",
    material: "Chart, dashboard, storytelling",
    instructor: "",
    outcome: "Mendapat materi membuat grafik, dashboard, mempelajari data storytelling.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  // Google Workspace Track
  {
    date: "02 Mar - 07 Mar",
    title: "Google Sheets Fundamentals",
    module: "Spreadsheet Basics",
    track: "Google Workspace",
    prerequisite: "",
    material: "Formula dasar, sorting, filtering",
    instructor: "",
    outcome: "Mempelajari formula dasar, sorting, filtering di Google Sheets beserta mempelajari latihan soal & jawaban yang sesuai kebutuhan industri.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  {
    date: "9 Mar - 14 Mar",
    title: "Data Analysis with Google Sheets",
    module: "Data Analysis Tools",
    track: "Google Workspace",
    prerequisite: "",
    material: "Pivot table, VLOOKUP/XLOOKUP",
    instructor: "",
    outcome: "Mendapat materi mengenai Pivot table, VLOOKUP/XLOOKUP pada Google Sheets beserta latihan soal & jawaban yang sesuai kebutuhan industri.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  {
    date: "31 Mar - 04 Apr",
    title: "Data Visualization with Google Sheets",
    module: "Visual Analytics",
    track: "Google Workspace",
    prerequisite: "",
    material: "Chart, dashboard sederhana",
    instructor: "",
    outcome: "Mempelajari cara membuat grafik & dashboard sederhana di Google Sheets beserta latihan soal & jawaban yang sesuai kebutuhan industri.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  {
    date: "06 Apr - 11 Apr",
    title: "Reporting with Google Docs",
    module: "Data Reporting",
    track: "Google Workspace",
    prerequisite: "",
    material: "Struktur laporan, insight writing",
    instructor: "",
    outcome: "Struktur laporan, insight writing",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  {
    date: "13 Apr - 18 Apr",
    title: "Presentation with Google Slides",
    module: "Data Storytelling",
    track: "Google Workspace",
    prerequisite: "",
    material: "Visual storytelling, slide design",
    instructor: "",
    outcome: "Membuat Visual Storytelling, Slide Design di Google Slides.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 1
  },
  // Data Analyst Track - Batch 2 (Popular Classes Repeated)
  {
    date: "20 Apr - 25 Apr",
    title: "Excel for Data Cleaning",
    module: "Excel Fundamentals",
    track: "Data Analyst",
    prerequisite: "",
    material: "Data cleaning, formatting, missing values",
    instructor: "",
    outcome: " Mendapat file Excel yang berisi proses Data cleaning, Formatting, Missing values.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 2,
    popular: true
  },
  {
    date: "27 Apr - 30 Apr",
    title: "Excel for Data Analysis",
    module: "Pivot & Insight",
    track: "Data Analyst",
    prerequisite: "",
    material: "Pivot table, aggregation",
    instructor: "",
    outcome: "Mempelajari Pivot Table & Aggregation di Excel.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 2,
    popular: true
  },
  {
    date: "04 Mei - 09 Mei",
    title: "SQL for Data Analyst",
    module: "SQL Fundamentals",
    track: "Data Analyst",
    prerequisite: "",
    material: "SELECT, WHERE, JOIN, GROUP BY",
    instructor: "",
    outcome: "Materi mengenai SELECT, WHERE, JOIN, GROUP BY beserta soal latihan & jawaban yang sesuai dengan kebutuhan industri.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 2,
    popular: true
  },
  {
    date: "11 Mei - 13 Mei",
    title: "Python for Data Analysis",
    module: "Exploratory Data Analysis",
    track: "Data Analyst",
    prerequisite: "",
    material: "Pandas, NumPy, EDA workflow",
    instructor: "",
    outcome: "Mempelajari librari Python seperti Pandas, NumPy, EDA Workflow di Google Colaboratory.",
    duration: "2 Jam",
    price: "Rp100.000",
    method: "Online",
    batch: 2,
    popular: true
  },
  // Data Science Track
  {
    date: "18 Mei - 23 Mei",
    title: "Statistics for Data Science",
    module: "Statistical Fundamentals",
    track: "Data Science",
    prerequisite: "Harus memiliki kemampuan analisis data.",
    material: "Descriptive statistics, distribution, correlation",
    instructor: "",
    outcome: "Mempelajari materi Descriptive Statistics, Distribution, Correlation",
    duration: "3 Jam",
    price: "Rp150.000",
    method: "Online",
    batch: 1
  },
  {
    date: "25 Mei - 30 Mei",
    title: "Probability & Hypothesis Testing",
    module: "Statistical Inference",
    track: "Data Science",
    prerequisite: "Harus memiliki kemampuan analisis data.",
    material: "Probability, hypothesis testing",
    instructor: "",
    outcome: "Memahami pengertian Probability, Hypothesis Testing",
    duration: "3 Jam",
    price: "Rp150.000",
    method: "Online",
    batch: 1
  },
  {
    date: "2 Juni - 6 Juni",
    title: "Regression Analysis",
    module: "Predictive Modeling",
    track: "Data Science",
    prerequisite: "Harus memiliki kemampuan analisis data.",
    material: "Linear regression",
    instructor: "",
    outcome: "Memahami Regresi Linear beserta penerapannya dalam Predictive Modeling.",
    duration: "3 Jam",
    price: "Rp150.000",
    method: "Online",
    batch: 1
  },
  {
    date: "8 Juni - 13 Juni",
    title: "Machine Learning Fundamentals",
    module: "ML Concepts",
    track: "Data Science",
    prerequisite: "Harus memiliki kemampuan analisis data.",
    material: "Supervised & unsupervised learning",
    instructor: "",
    outcome: "Mempelajari Supervised & Unsupervised Learning beserta konsep dasar Machine Learning.",
    duration: "3 Jam",
    price: "Rp150.000",
    method: "Online",
    batch: 1
  },
  {
    date: "15 Juni - 20 Juni",
    title: "Model Evaluation",
    module: "Evaluation Metrics",
    track: "Data Science",
    prerequisite: "Harus memiliki kemampuan analisis data.",
    material: "Accuracy, precision, recall, RMSE",
    instructor: "",
    outcome: "Paham mengenai Accuracy, Precision, Recall, RMSE.",
    duration: "3 Jam",
    price: "Rp150.000",
    method: "Online",
    batch: 1
  },
  {
    date: "22 Juni - 27 Juni",
    title: "Feature Engineering",
    module: "Data Preparation",
    track: "Data Science",
    prerequisite: "Harus memiliki kemampuan analisis data.",
    material: "Feature selection, transformation",
    instructor: "",
    outcome: "Paham mengenai Feature Selection, Data Transformation.",
    duration: "3 Jam",
    price: "Rp150.000",
    method: "Online",
    batch: 1
  },
  // Bundling Track
  {
    date: "1 Juli - 31 Agustus",
    title: "Data Analyst Bootcamp - Complete Package",
    module: "Full Data Analyst Program",
    track: "Bundling",
    prerequisite: "",
    material: "Business thinking, Excel, SQL, Python, Visualization & Storytelling - semua materi Data Analyst dalam 1 paket",
    instructor: "",
    outcome: "Siap menjadi Data Analyst profesional dengan skill lengkap & sesuai kebuutuhan industri.",
    duration: "2 Bulan (24 sesi @2 jam)",
    price: "Rp500.000",
    method: "Online",
    batch: 1,
    popular: true
  },
  {
    date: "1 Juli - 31 Agustus",
    title: "Google Workspace Mastery - Complete Package",
    module: "Full Google Workspace Program",
    track: "Bundling",
    prerequisite: "",
    material: "Google Sheets Fundamentals, Data Analysis, Visualization, Docs Reporting, Slides Presentation - semua dalam 1 paket",
    instructor: "",
    outcome: "Kuasai Google Workspace untuk produktivitas dan analisis data.",
    duration: "2 Bulan (20 sesi @2 jam)",
    price: "Rp450.000",
    method: "Online",
    batch: 1
  },
  {
    date: "1 September - 31 Oktober",
    title: "Data Science Bootcamp - Complete Package",
    module: "Full Data Science Program",
    track: "Bundling",
    prerequisite: "Harus memiliki kemampuan analisis data dasar (Excel/Python)",
    material: "Statistics, Probability, Regression, Machine Learning, Model Evaluation, Feature Engineering - paket lengkap Data Science",
    instructor: "",
    outcome: "Siap menjadi Data Scientist dengan kemampuan Machine Learning.",
    duration: "2 Bulan (24 sesi @3 jam)",
    price: "Rp800.000",
    method: "Online",
    batch: 1,
    popular: true
  },
  {
    date: "1 September - 31 Oktober",
    title: "Data Professional Ultimate Bundle",
    module: "Complete Data Journey",
    track: "Bundling",
    prerequisite: "",
    material: "Semua kelas Data Analyst + Data Science - dari dasar hingga mahir machine learning",
    instructor: "",
    outcome: "Menjadi data professional yang komprehensif dari analyst hingga scientist",
    duration: "4 Bulan (48 sesi)",
    price: "Rp1.200.000",
    method: "Online",
    batch: 1,
    popular: true
  }
];
